import { useState, useEffect } from "react";

let listeners = [];
let state = {
  web_version: "1.0.0",
  verifiedCaptcha: false,
  fondue_base_api_url: "https://neo-fondue.traffy.in.th/v1/",
  org_raduis: 100,
  current_coors: [],
  select_map_types: "marker",
  address_from_google: "",
};

const setState = (newState) => {
  state = { ...state, ...newState };
  listeners.forEach((listener) => {
    listener(state);
  });
};

const useCustom = () => {
  const newListener = useState()[1];
  useEffect(() => {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};

export default useCustom;
